import { useEffect } from 'react';

import { ONE_SECOND } from '@air/utilities';

const SKIP_ONBOARDING_WORKSPACES_POLL_MS = ONE_SECOND;

export type UseHandleSkipOnboardingWorkspacesPollParams = {
  hasWorkspaces: boolean;
  refetchWorkspaces: () => unknown;
  shouldSkipOnboarding: boolean;
};

/**
 * While `skipOnboarding` is active and the current tab has not observed any workspaces yet,
 * poll for workspaces created by another tab (e.g. a concurrent skip-onboarding creation that
 * won the Web Lock) so this tab can pick up the redirect without the user refreshing.
 */
export const useHandleSkipOnboardingWorkspacesPoll = ({
  hasWorkspaces,
  refetchWorkspaces,
  shouldSkipOnboarding,
}: UseHandleSkipOnboardingWorkspacesPollParams) => {
  useEffect(() => {
    if (!shouldSkipOnboarding || hasWorkspaces) {
      return;
    }

    const refetch = () => {
      void refetchWorkspaces();
    };

    const intervalId = window.setInterval(refetch, SKIP_ONBOARDING_WORKSPACES_POLL_MS);
    window.addEventListener('storage', refetch);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('storage', refetch);
    };
  }, [hasWorkspaces, refetchWorkspaces, shouldSkipOnboarding]);
};
